import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';
import { FeatureFlagService } from '@ridango/feature-flags';
import { takeUntil } from 'rxjs/operators';
import { CompanyFacade } from '@ridango/components';

import { FEATURE_FLAGS } from '@ridango/core';
import { TicketHistoryFacade } from '@ridango/components/lib/ticket-history';

@Component({
    selector: 'gl-account-parent-page',
    templateUrl: './account-parent-page.component.html',
    styleUrls: ['./account-parent-page.component.scss']
})
export class AccountParentPageComponent extends BaseComponent implements OnInit, OnDestroy {
    selectedCompany$ = this.companyFacade.selectedCompany$;

    profileParentPageActions: string[] = this.env.ACCOUNT.ACTIONS;
    showBookARide = true;
    isDepartment: boolean;

    constructor(
        @Inject('ENV') public env: Env,
        private ticketHistoryFacade$: TicketHistoryFacade,
        private featureFlags: FeatureFlagService,
        private companyFacade: CompanyFacade
    ) {
        super();
    }

    ngOnInit(): void {
        this.featureFlags
            .getFlags(FEATURE_FLAGS.BookARide)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((flagValue) => {
                this.showBookARide = flagValue;
            });

        this.selectedCompany$.pipe(takeUntil(this.componentDestroyed$)).subscribe((selected) => {
            this.isDepartment = !!(selected && selected.parentCompany && selected.parentCompany.id);
        });
    }

    ngOnDestroy() {
        this.ticketHistoryFacade$.resetTicketHistorySearchFilter();
    }
}
